"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarketingSiteHostUrlForRegion = exports.API_ENDPOINTS = exports.ENVIRONMENTS = exports.getCookieDomain = exports.getDomainForLocation = exports.getDomainForHostname = exports.IGNORED_PARTNER_HANDLES = exports.BEMER_DOMAINS = exports.BEMER_HOSTNAMES = void 0;
var ENVIRONMENT_NAMES = [
    'local_dev',
    'example_dev',
    'playground',
    'development',
    'cms_preview_development',
    'stage',
    'cms_preview_stage',
    'production_test',
    'production',
];
var ENVIRONMENTS = Object.fromEntries(ENVIRONMENT_NAMES.map(function (name) { return [["".concat(name.toUpperCase())], name]; }));
exports.ENVIRONMENTS = ENVIRONMENTS;
/**
 * A map of environment names to the domain it runs on.
 */
var BEMER_HOSTNAMES = {
    local_dev: 'localhost',
    // in order to use example.org, run `yarn addHostname` first
    example_dev: 'example.org',
    playground: 'dev.bemer.services',
    development: 'dev.bemer.services',
    cms_preview_development: 'dev.bemer.services',
    stage: 'stage.bemer.services',
    cms_preview_stage: 'stage.bemer.services',
    production_test: 'b3m3r.com',
    production: 'bemergroup.com',
};
exports.BEMER_HOSTNAMES = BEMER_HOSTNAMES;
/**
 * A list of subdomains which are allowed in the BEMER universe, but must not be resolved as partner handles.
 *
 */
var IGNORED_PARTNER_HANDLES = ['www'];
exports.IGNORED_PARTNER_HANDLES = IGNORED_PARTNER_HANDLES;
/**
 * An array of all available domains.
 *
 * The `new Set` makes them unique.
 */
var BEMER_DOMAINS = __spreadArray([], __read(new Set(Object.keys(BEMER_HOSTNAMES).map(function (environment) { return BEMER_HOSTNAMES[environment]; }))), false);
exports.BEMER_DOMAINS = BEMER_DOMAINS;
/**
 * Helper to get a domain for a given hostname.
 *
 * The given hostname can contain a partner subdomain like "partnerABC.bemergroup.com".
 * Such a hostname would return the domain "bemergroup.com", since it is included in
 * the hostname.
 *
 * @param hostname
 */
var getDomainForHostname = function (hostname) {
    var foundDomain = BEMER_DOMAINS.find(function (domain) { return hostname.indexOf(domain) > -1; });
    if (!foundDomain) {
        throw new Error('No known domain found in the given hostname.');
    }
    return foundDomain;
};
exports.getDomainForHostname = getDomainForHostname;
/**
 * Convenience helper to get a domain for a given location. Calls getDomainForHostname.
 *
 * @param location
 */
var getDomainForLocation = function (location) {
    return getDomainForHostname(location.hostname);
};
exports.getDomainForLocation = getDomainForLocation;
/**
 * Helper to get the cookie domain params for the current URL.
 */
var getCookieDomain = function () {
    // Do nothing when SSR.
    if (typeof window === 'undefined') {
        throw new Error('It is not possible to get the cookie domain in a server environment.');
    }
    return window.location.hostname === 'localhost'
        ? ''
        : " ;domain=".concat(getDomainForHostname(window.location.hostname));
};
exports.getCookieDomain = getCookieDomain;
var PROTOCOL = 'https://';
// ENVIRONMENT_BEMER_MARKETING can be one of the ENVIRONMENTS.
var environment = process.env.GATSBY_ENVIRONMENT ||
    process.env.ENVIRONMENT_BEMER_MARKETING ||
    process.env.SANITY_STUDIO_ENVIRONMENT_BEMER_MARKETING ||
    process.env.GATSBY_ENVIRONMENT_BEMER_MARKETING;
var fallbackEnvironment = process.env.NODE_ENV === 'development'
    ? ENVIRONMENTS.PLAYGROUND
    : ENVIRONMENTS.STAGE;
var currentEnvironment = environment || fallbackEnvironment;
var endpointUrlPrefixBemerMarketing;
var getHostUrl = function (regionHandle) {
    var subdomain = regionHandle ? "".concat(regionHandle, ".") : '';
    return "".concat(PROTOCOL).concat(subdomain).concat(BEMER_HOSTNAMES[currentEnvironment]);
};
var bemerMarketingSiteUrls = {
    USA: getHostUrl(),
    EUROPE: getHostUrl(),
    ITALY: getHostUrl(),
    WORLD: getHostUrl(),
    CANADA: getHostUrl(),
};
// use these alternative values for local testing of language picker functionality
// const bemerMarketingSiteUrls: TMarketingSiteHostUrls = {
//   USA: getHostUrl(),
//   EUROPE: 'http://localhost:8000',
//   ITALY: 'http://localhost:8000',
//   WORLD: 'http://localhost:8000',
//   CANADA: 'http://localhost:8000',
// };
/**
 * Returns the marketingSite hosturl for a specific region
 *
 * @param localeIdentifier
 */
var getMarketingSiteHostUrlForRegion = function (regionCode) {
    var hostUrl = bemerMarketingSiteUrls[regionCode];
    if (!hostUrl) {
        throw new Error("No known hostUrl found for the given region: ".concat(regionCode, "."));
    }
    return hostUrl;
};
exports.getMarketingSiteHostUrlForRegion = getMarketingSiteHostUrlForRegion;
switch (currentEnvironment) {
    case ENVIRONMENTS.DEVELOPMENT:
    case ENVIRONMENTS.PLAYGROUND:
    case ENVIRONMENTS.STAGE:
    case ENVIRONMENTS.PRODUCTION:
    case ENVIRONMENTS.CMS_PREVIEW_DEVELOPMENT:
    case ENVIRONMENTS.CMS_PREVIEW_STAGE: {
        endpointUrlPrefixBemerMarketing = "".concat(PROTOCOL).concat(BEMER_HOSTNAMES[currentEnvironment]);
        break;
    }
    default: {
        endpointUrlPrefixBemerMarketing = '';
    }
}
var API_ENDPOINTS = {
    BEMER_MARKETING: "".concat(endpointUrlPrefixBemerMarketing, "/api"),
    PARTNER_FINDER: "".concat(endpointUrlPrefixBemerMarketing, "/address"),
    EVENTS: "".concat(endpointUrlPrefixBemerMarketing, "/ep"),
};
exports.API_ENDPOINTS = API_ENDPOINTS;
